export default __webpack_public_path__ + "ed6af549513d3edb3915ba767dbcc485.png";